import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
  EditButton,
  DeleteButton,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const FinjamWalletList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "project_id",
        title: "Project Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "project_name",
        title: "Project Name",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "wallet_addr",
        title: "Wallet Address",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "api_key",
        title: "API Key",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "start_date",
        title: "Start Date",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "stop_date",
        title: "Stop Date",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      // {
      //   dataIndex: "actions",
      //   title: "Actions",
      //   render: (_, record) => {
      //     return (
      //       <>
      //         <EditButton hideText recordItemId={record.project_id} />
      //         <DeleteButton hideText recordItemId={record.project_id} />
      //       </>
      //     );
      //   },
      //   align: "center",
      //   headerAlign: "center",
      //   width: 80,
      //   fixed: "right",
      // },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
